/** Нормализованный ключ ролика по ссылке: «платформа:id». null — ссылку нельзя разобрать офлайн. */
export function videoLinkKey (raw) {
  let url;
  try {
    const text = String(raw || '').trim();
    url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`);
  } catch { return null; }
  const host = url.hostname.toLowerCase().replace(/^(www|m|mobile)\./, '');
  const parts = url.pathname.split('/').filter(Boolean);
  const after = (...names) => {
    const i = parts.findIndex((p) => names.includes(p.toLowerCase()));
    return i >= 0 ? parts[i + 1] : undefined;
  };
  const key = (platform, id) => (id ? `${platform}:${id}` : null);
  if (host === 'instagram.com' || host === 'instagr.am') return key('ig', after('reel', 'reels', 'p', 'tv'));
  if (host === 'tiktok.com') return /^@/.test(parts[0] || '') && parts[1] === 'video' ? key('tt', parts[2]) : null;
  if (host === 'youtu.be') return key('yt', parts[0]);
  if (host === 'youtube.com' || host === 'music.youtube.com') return key('yt', url.searchParams.get('v') || after('shorts', 'embed', 'live'));
  if (host === 'facebook.com') return key('fb', url.searchParams.get('v') || after('reel', 'videos'));
  return null;
}

/** Разбор вставленного текста на ссылки: по строкам и пробелам. */
export function splitLinks (text) {
  return String(text || '').split(/\s+/).filter(Boolean);
}

/** Решение по одной вставленной ссылке над строками API (paidAt/rejectedAt): { row } — можно отклонять, { text } — итог без запроса. */
export function decideLinkRejection (link, bonuses) {
  const key = videoLinkKey(link);
  if (!key) return { text: 'не найдено, вставьте полную ссылку' };
  const row = (bonuses || []).find((b) => videoLinkKey(b.postUrl) === key);
  if (!row) return { text: 'не найден среди миллионников этого блогера' };
  if (row.paidAt) return { text: 'оплачен — нельзя' };
  if (row.rejectedAt) return { text: 'уже отклонён' };
  return { row };
}
